import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=48902cb3&scoped=true"
import script from "./Node.vue?vue&type=script&lang=js"
export * from "./Node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48902cb3",
  null
  
)

export default component.exports